module.exports = __webpack_public_path__ + "static/media/barbitistes_serricauda.b991ba13.jpg";